import { useTranslation } from "react-i18next";

export const useLocale = (props) => {
  const { t, i18n } = useTranslation(props);
  return {
    localize: t,
    i18n,
  };
};
